import { ACTION, BOOLEAN, STRING } from '../../../utils/component-validations';
import { on } from '@ember/modifier';
import FlexRow from '../layout/flex/row.gjs';
import Super from './base.gjs';
import styles from './label.module.scss';

const METADATA = {
  component: 'Spds::Core::Label',
  description: 'SPDS-compliant label component',
  name: 'Label',
  meta: {
    for: {
      description: 'The ID of the form element this label is associated with',
      type: STRING,
    },
    label: {
      description: 'The label text to display',
      initialValue: 'Label',
      type: STRING,
    },
    onClick: {
      description: 'Action to be called when the label is clicked',
      type: ACTION,
    },
    required: {
      defaultValue: false,
      description: 'Indicates whether the associated field is required',
      type: BOOLEAN,
    },
    srOnly: {
      defaultValue: false,
      description: 'Visually hides the label while keeping it accessible to screen readers',
      type: BOOLEAN,
    },
  },
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/blob/staging/addon/src/components/spds/core/label.gjs',
  },
};

export default class SpdsCoreLabel extends Super {
  static metadata = this.setMetadata(METADATA);
  classesToMapToArgs = ['srOnly', 'required'];
  baseClass = 'spds-label';
  componentName = 'Spds::Core::Label';
  styles = styles;

  handleClick = evt => {
    if (!this.args.onClick) return;

    evt.preventDefault();

    this.args.onClick();
  };

  <template>
    <FlexRow
      @content={{@label}}
      @tag="label"
      class={{this.classes}}
      data-test-spds-label={{this.componentName}}
      id={{this.id}}
      for={{@for}}
      {{this.validateArguments}}
      {{on "click" this.handleClick}}
      ...attributes
    >
      {{yield}}
    </FlexRow>
  </template>
}

export const SPDS_CORE_LABEL_METADATA = SpdsCoreLabel.metadata;
